import {useState, useEffect} from 'react';
import {Box, styled} from '@mui/material';

interface CarouselProps {
    images: string[];
}

const CarouselContainer = styled(Box)({
    width: '100%',
    position: 'relative'
});

const CarouselImage = styled('img')({
    width: '100%',
    height: 'auto',
    display: 'block',
    transition: 'opacity 0.8s ease-in-out',
    WebkitUserDrag: 'none'
});

const Carousel = ({images}: CarouselProps) => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <CarouselContainer>
            {images.map((img, index) => (
                <CarouselImage
                    key={index}
                    src={img}
                    alt={`Slide ${index + 1}`}
                    sx={{
                        opacity: index === current ? 1 : 0,
                        position: index === current ? 'relative' : 'absolute',
                        top: index === current ? 'auto' : 0,
                        left: index === current ? 'auto' : 0
                    }}
                />
            ))}
        </CarouselContainer>
    );
};

export default Carousel;